import {Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import {AppComponentName, Event, Message, MessageActionType, MessageType, Sensor, TimeZoneDisplay, UserAccessType, UserGroup } from '@models';
import {DeviceService} from '@services/device.service';
import moment from 'moment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {ConfirmationService} from 'primeng/api';
import {SensorService} from '@services/sensor.service';
import {SensorGroupService} from '@services/sensorgroup.service';
import {UserService} from '@services/user.service';
import {AppComponent} from '../../app.component';
import {AppMessageService} from '@services/message.service';
import {ActivatedRoute} from '@angular/router';
import {debounce} from 'lodash-es';
import {HubConnectionState} from '@microsoft/signalr';
import {EMPTY, from} from 'rxjs';
import {Observable} from 'rxjs';
import {HubConnectionFactory} from '@services/hub-connection-factory.service';
import Timeout = NodeJS.Timeout;
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import { EditActionQueuesParams as EditActionQueueParams, EditActionQueueComponent } from './edit-action-queues/edit-action-queues.component';
import { ActionQueueService } from '@services/actionQueue.service';
import { EventMapper } from '../trigger-settings/trigger.mapping';
import { TriggerService } from '../trigger-settings/trigger.service';
import { ActionQueue, ActionQueueRules } from '@models/ActionQueue/ActionQueue.model';
import { ViewActionQueueComponent, ViewActionQueueParams } from './view-action-queues/view-action-queues.component';
import { ActionQueueLive } from '@models/ActionQueue/ActionQueueLive.model';
import { SensorDataModalParams, SensorDataModalComponent } from '../sensors/sensor-data-modal/sensor-data-modal.component';


const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');

@Component({
  standalone: false,
  selector: 'app-action-queues',
  templateUrl: './action-queues.component.html',
  styleUrls: [ './action-queues.component.scss' ],
})

export class ActionQueuesComponent implements OnInit, OnDestroy {

  auth = new Authorization();
  common = new CommonShared();
  
  modalDragOn: boolean = false;

  searchRecallTimer?: Timeout;
  actionQueueSearchText = '';
  eventUpdateDisplayTimer?: Timeout;
  events: Event[] = [];
  eventsDisplayed: Event[] = [];
  eventsCheckedCount: number = 0;

  event: Event = new Event();
  eventMapper = new EventMapper();
  userGroups: UserGroup[] = [];
  associatedUserGroups: UserGroup[] = [];
  selectedUserGroup: UserGroup;

  actionQueues: ActionQueue[] = [];
  actionQueue: ActionQueue = new ActionQueue();
  actionQueuesDisplayed: ActionQueue[] = [];

  username = 'unknown';
  preEditObjectAsJSONString = '';
  changeLogNotes = '';

  readonly globalSwitch: boolean;

  actionQueueTableCols = [
    {field: 'name', header: 'Name', width: '27%' },
    {field: 'displayedOwner', header: 'Owner', width: '19%' },
    {field: 'modifiedDate', header: 'Modified', width: '24%' },
    {field: 'chartQueueStats', header: 'Stats', width: '6%' },
    {field: 'numEvents', header: '#Events', width: '6%' },
    {field: 'queuedEventActions', header: 'Queued', width: '6%' },
    //{field: 'copy', header: 'Copy', width: '5%' },
    {field: 'edit', header: 'Edit', width: '6%' },
    {field: 'delete', header: 'Del', width: '6%' }
  ];

  actionQueuesLoaded = true;
  eventsLoaded = true;
  associatedUserGroupsLoaded = true;
  userGroupsLoaded = true;

  logConfig = {
    size: 'lg',
    backdrop: false,
    ignoreBackdropClick: false
  };

  config = {
    backdrop: false,
    ignoreBackdropClick: true
  };

  editActionQueuesModalRef: BsModalRef;
  hubConnection: signalR.HubConnection;


  constructor(private toastr: ToastrService, private modalService: BsModalService, private confirmationService: ConfirmationService,
              public global: AppComponent, public _userService: UserService, private _triggerService: TriggerService,
              private _actionQueueService: ActionQueueService, private hubFactory: HubConnectionFactory,
              public _appMessageService: AppMessageService, private route: ActivatedRoute, public _sensorService: SensorService) {
    this.globalSwitch = global.globalSwitch;

    this.hubConnection = this.hubFactory.create('/api/hubs/eventaction');
    this.hubConnection.onclose(() => console.log('hubConnection.onclose') );
    this.hubConnection.onreconnecting(() => console.log('Attempting reconnect...') );
    this.hubConnection.onreconnected(() => console.log('Reconnected.') );
    this.hubConnection.on('refreshEvent', (updateType: string, updatedEvent: string) => this.refreshEvent(updateType, updatedEvent));
  }


  ngOnInit(): void {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      () => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp(): void {
    this.actionQueue = this.newActionQueue();
    this.getAssociatedUserGroups();
    this.startSignalR();
  }

  
  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  private startSignalR(): Observable<any> {
    return (this.hubConnection.state === HubConnectionState.Disconnected) ? from(this.hubConnection.start()) : EMPTY;
  }


  public ngOnDestroy(): void {
    this.stopSignalR();
  }


  private stopSignalR() {
    this.hubConnection.stop();
  }


  private refreshEvent(updateType: string, updatedEventInfo: string) {
    switch (updateType.toLowerCase()) {
    case 'edit':
      this.refreshEventOnEdit(updatedEventInfo);
      break;
    case 'new':
      this.refreshEventOnNew(updatedEventInfo);
      break;
    case 'del':
      this.refreshEventOnDel(updatedEventInfo);
      break;
    case 'editignore':
      this.refreshEventIgnore(updatedEventInfo);
      break;
    default:
      break;
    }
  }


  public refreshEventOnEdit(updatedEvent: string): void {
  }


  public refreshEventIgnore(updatedEventInfo: string): void {
  }


  public refreshEventOnNew(updatedEvent: string): void {
  }


  public refreshEventOnDel(updatedEventID: string): void {
  }


  getAssociatedUserGroups(): void {
    this.associatedUserGroupsLoaded = false;

    this._userService.getAssociatedUserGroups(this.username).subscribe(
      results => {
        if (results != null) {
          this.associatedUserGroups = results;
          this.associatedUserGroupsLoaded = true;
          this.getUserGroups();
        }
        
        return;
      },
      () => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getUserGroups(): void {
    this.userGroupsLoaded = false;
    this._userService.getUserGroups().subscribe(
      results => {
        if (results != null) {
          this.userGroups = results;
          this.userGroupsLoaded = true;
          this.getEvents();
        }
        else {
          this.toastr.warning('No user groups found');
        }
        return;
      },
      () => {
        this.toastr.error('Error occurred while retrieving all user groups');
      });
  }


  newActionQueue(): ActionQueue {
    const actionQueue: ActionQueue = {
      id: 0,
      name: '',
      userName: this.username,
      userId: -1,
      userGroupName: '',
      userGroupId: -1,
      userAccess: UserAccessType.Read,
      modifiedDate: undefined,
      rules: '',
      rulesObj: new ActionQueueRules(),
      queued: [],
      queuedWaiting: [],
      queuedHistory: [],
      eventIds: [],
      queuedActive: 0,
      saveQueueHistoryDays: 1
    }

    return actionQueue;
  }

  
  getActionQueues(forceReload: boolean): void {
    this.actionQueuesLoaded = false;

    this._actionQueueService.getActionQueues('Loading Action Queues', forceReload).subscribe(
      results => {
        if (results != null) {
          this.actionQueues = results;

          this.actionQueues.forEach(actionQueue => {
            this.auth.mapUserAccessForActionQueue(actionQueue, false, this.username, this.userGroups);
            actionQueue.eventIds = (actionQueue.eventIds == null) ? [] : actionQueue.eventIds;
            actionQueue.queued = (actionQueue.queued == null) ? [] : actionQueue.queued;
            actionQueue.modifiedDate = moment.utc(actionQueue.modifiedDate).local().toDate();
            actionQueue.queuedActive = actionQueue.queued.filter(a => a.status == 'active').length;
            actionQueue.saveQueueHistoryDays = (actionQueue.saveQueueHistoryDays == null || actionQueue.saveQueueHistoryDays < 1) ? 3 : actionQueue.saveQueueHistoryDays;

            actionQueue.queued.forEach(x => {
              var event = this.events.find(e => e.id === x.eventId);
              if (event != null) {
                x.eventName = event.name;
                x.actionType = this.common.getEventActionLabelForEvent(event);
                x.createdDate = moment.utc(x.createdDate).local().toDate();
                x.modifiedDate = moment.utc(x.modifiedDate).local().toDate();
                x.activeDate = moment.utc(x.activeDate).local().toDate();
              }
              this.common.setStatusColorForActionQueueLiveItem(x);
            });

            actionQueue.queuedWaiting = actionQueue.queued.filter(q => q.status.toLowerCase() == 'waiting');
            actionQueue.queuedHistory = actionQueue.queued.filter(q => q.status.toLowerCase() != 'waiting');

            this.common.sortActionQueueByColumn(actionQueue.queuedHistory, 'modifiedDate', false);
            this.common.sortActionQueueByColumn(actionQueue.queuedWaiting, 'orderNum', true);
            this.common.sortActionQueueByColumn(actionQueue.queued, 'createdDate', false);
          });

          this.actionQueue = (this.actionQueues == null || this.actionQueues.length === 0) ? this.newActionQueue() : this.actionQueues[0];

          this.actionQueuesLoaded = true;
          this.actionQueuesDisplayed = this.actionQueues.filter(x => x.userFeatureAccess['ViewActionQueue']);
        }
      },
      () => {
        this.toastr.error('Error occurred while retrieving action queues');
      });
  }


  getEvents(): void {
    this.eventsLoaded = false;

    this._triggerService.getEvents('Loading Events ...').subscribe(
      results => {
        if (results != null) {
          this.events = this.eventMapper.mapEventInfos2Events(results);
          this.events.forEach(e => {
            this.auth.mapUserAccessForEvent(e, this.globalSwitch, this.username, this.userGroups);
          });

          this.events.sort((a, b) => a.name!.localeCompare(b.name!));

          this.eventsLoaded = true;
          this.getActionQueues(false);

          this.startTimer4RecallLastSearchFilter();
        } else {
          this.toastr.warning('No Events found.');
        }
        return;
      },
      () => {
        this.toastr.error('Error occurred while retrieving Event list.');
      });
  }


  createActionQueue(): void {
    this.changeLogNotes = '';

    this.actionQueue = this.newActionQueue();
    // this.selectedUserGroup = this.associatedUserGroups.find(u => u.id === -1);
    this.actionQueue.userName = this.username;
    this.auth.mapUserAccessForActionQueue(this.actionQueue, this.globalSwitch, this.username, this.userGroups);

    const params: EditActionQueueParams = {
      events: this.events,
      userGroups: this.userGroups,
      associatedUserGroups: this.associatedUserGroups,
      actionQueue: this.actionQueue,
      actionQueues: this.actionQueues
    };

    this.modalService.show(EditActionQueueComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params })
      .onHide
      .subscribe({ next: () => this.getActionQueues(true) });
  }


  editActionQueue(actionQueue: ActionQueue): void {
    this.changeLogNotes = '';

    // if (actionQueue.userGroupId == null) {
    //   this.selectedUserGroup = this.associatedUserGroups.find(u => u.id === -1);
    // } else {
    //   this.selectedUserGroup = this.associatedUserGroups.find(u => u.id === actionQueue.userGroupId);
    // }

    this.actionQueue = this.cloneActionQueue(actionQueue);
    this.preEditObjectAsJSONString = JSON.stringify(this.event);

    const params: EditActionQueueParams = {
      events: this.events,
      userGroups: this.userGroups,
      associatedUserGroups: this.associatedUserGroups,
      actionQueue: this.actionQueue,
      actionQueues: this.actionQueues
    };

    this.modalService.show(EditActionQueueComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params })
      .onHide
      .subscribe({ next: () => this.getActionQueues(true) });
  }


  onDeleteActionQueueConfirm(actionQueue: ActionQueue): void {
    this.confirmationService.confirm({
      message: 'Delete the Action Queue named \'' + actionQueue.name + '\'?',
      header: 'Delete Confirmation',
      icon: 'glyphicon glyphicon-warning-sign',
      accept: () => {
        this._actionQueueService.deleteActionQueue(actionQueue).subscribe(
          results => {
            if (results != null) {
              this.createMessageData(MessageActionType.Deleted, actionQueue, '');
              this.toastr.success('Success');
              this.getActionQueues(true);
            } else {
              this.toastr.warning('No trigger found.');
            }
            return;
          },
          () => {
            this.toastr.error('Error occurred while deleting trigger. Reload page');
          });
      },
      reject: () => {
      }
    });
  }


  copyActionQueue(actionQueue: ActionQueue): void {
    let copyIndex: number;
    for (copyIndex = 1; copyIndex < 500; copyIndex++) {
      const results = this.actionQueues.findIndex(t => t.name === actionQueue.name + ' (copy ' + copyIndex + ')');
      if (results === -1) {
        break;
      }
    }

    const newActionQueue = Object.assign({}, actionQueue);
    newActionQueue.id = 0;
    newActionQueue.name = actionQueue.name + ' (copy ' + copyIndex + ')';

    this._actionQueueService.createActionQueue(newActionQueue).subscribe(
      results => {
        if (results != null) {
          this.toastr.success('Successfully copied ' + actionQueue.name);
          this.getActionQueues(true);
        } else {
          this.toastr.warning('Not found.');
        }
        return;
      },
      () => {
        this.toastr.error('Error occurred while copying Action Queue.');
      });
  }


  cloneActionQueue(actionQueue: ActionQueue): ActionQueue {
    const newActionQueue: ActionQueue = JSON.parse(JSON.stringify(actionQueue));
    newActionQueue.modifiedDate = actionQueue.modifiedDate;
    return newActionQueue;
  }


  startTimer4RecallLastSearchFilter(): void {
    this.searchRecallTimer = setTimeout(() => {
      // A link (e.g. from the home page search) can pass the text to search with ?search=
      const linkedSearch = this.route.snapshot.queryParamMap.get('search');
      this.actionQueueSearchText = linkedSearch ?? localStorage.getItem('ActionQueueSearchBox');
      this.searchActionQueuesTextChanged();
    },500);
  }


  clearSearchFilter(): void {
    this.actionQueueSearchText = '';
    this.searchActionQueuesTextChanged();
  }


  searchActionQueuesTextChanged() {
    localStorage.setItem('ActionQueueSearchBox', this.actionQueueSearchText);

    var searchResults: ActionQueue[] = [];
    const searchLimit = 200;
    let checkedCount = 0;
    
    if (this.actionQueueSearchText == undefined || this.actionQueueSearchText == '' || this.actionQueueSearchText == 'null') {
      searchResults = [];
    }
    else if (this.actionQueueSearchText == '*') {
      searchResults = this.actionQueues;
    }
    else {
      this.actionQueueSearchText = this.actionQueueSearchText.toLowerCase();
      searchResults = this.actionQueues.filter(s => (s.name != undefined ? s.name.toLowerCase().includes(this.actionQueueSearchText) : false) );
    }

    const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

    var actionQueueIds = searchResults.slice(0, displayCount).map(x => x.id);
    this.actionQueuesDisplayed = this.actionQueues.filter(x => actionQueueIds.includes(x.id) && x.userFeatureAccess['ViewActionQueue']);

    this.actionQueuesDisplayed.sort((a, b) => {
      if (b.name > a.name) {
        return -1;
      }
      if (b.name < a.name) {
        return 1;
      }
    }); 
  }


  // editActionQueue() {
  //   const params: EditActionQueuesParams = {
  //     events: this.events,
  //     userGroups: this.userGroups,
  //     associatedUserGroups: this.associatedUserGroups
  //   };

  //   this.editActionQueuesModalRef = this.modalService.show(EditActionQueuesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  // }


  getOwnerName(actionQueue: ActionQueue): string {
    if (actionQueue.userGroupId == null) {
      return actionQueue.userName;
    } else {
      return actionQueue.userGroupName;
    }
  }


  openQueuedEventActions(actionQueue: ActionQueue) {
    const params: ViewActionQueueParams = {
      actionQueue: actionQueue,
      userGroups: this.userGroups,
      associatedUserGroups: this.associatedUserGroups
    };

    this.modalService.show(ViewActionQueueComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }


  createMessageData(msgActionType: MessageActionType, actionQueue: ActionQueue, msgNote: string): void {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.EventAndActions,
      actionType: msgActionType,
      appComponentItem: actionQueue.name,
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: actionQueue.userGroupId
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      () => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  refreshQueueStatus(): void {
    this.getActionQueues(true);
  }

  
  showSensorDataPreview(actionQueue: ActionQueue): void {
    var sensorUID = "actionqueue-" + actionQueue.id.toString();

    this._sensorService.getSensorWithUid(sensorUID).subscribe(
      results => {
        if (results != null) {
          var sensor: Sensor = results;

          var selectedTimeZone: TimeZoneDisplay = TimeZoneDisplay.Local;
          var selectedTimeZoneOffset: number = moment().utcOffset();

          [selectedTimeZone, selectedTimeZoneOffset] = this.common.setTimeZoneSelection(localStorage.getItem('TimeZoneSelected'));

          const params: SensorDataModalParams = {
            sensor: sensor,
            selectedTimeZone: selectedTimeZone,
            selectedTimeZoneOffset: selectedTimeZoneOffset,
            selectedDateRange: { startDate: moment().startOf('day').subtract(1, 'days'), endDate: moment().endOf('day') },
            selectedDefaultReadingType: ''
          };

          this.modalService.show(SensorDataModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
        } else {
          this.toastr.warning(`Sensor '${sensorUID}' not found.`);
        }
        return;
      },
      () => {
        this.toastr.error(`Error occurred while looking up sensor '${sensorUID}'.`);
    });
  }


  
}